import { MUNICIPALITIES_BY_COUNTY } from '../views/forms/municipalities.constants'

export const getDate18YearsAgo = () => {
  const today = new Date()
  today.setFullYear(today.getFullYear() - 18)
  return today
}

export const getInputClasses = (
  errorsExist: boolean = false,
  inputEntered: boolean = false,
) => {
  const extraClass = errorsExist
    ? ' input--error'
    : inputEntered
    ? ' input--entered'
    : ''
  return `input${extraClass}`
}

export const getMunicipalitiesByCounty = (state: any) => {
  if (!state['county']) {
    return MUNICIPALITIES_BY_COUNTY.Adams
  }
  const key = state['county'] as string
  return (MUNICIPALITIES_BY_COUNTY as never)[key] as string[]
}
